import React from 'react';
import { Text, TouchableOpacity, View } from 'react-native';
import { Image } from 'react-native-web';
import { img_close } from '../../utils/ImagesManagementUtils';

const TableBubble = ({ text, removeService }) => {
  const styles = {
    closeImage: {
      height: 16,
      width: 16,
    },
    bubble: {
      background: '#edf2f7',
      borderRadius: 12,
      border: 'solid 1px #cbd5e0',
      flexDirection: 'row',
      padding: 3,
      paddingStart: 8,
      margin: 3,
    },
    textStyle: {
      fontSize: 12,
    },
  };

  return (
    <View style={styles.bubble}>
      <Text style={styles.textStyle}>{text}</Text>
      <TouchableOpacity
        style={styles.closeImage}
        onPress={removeService}
      >
        <Image
          style={styles.closeImage}
          source={img_close}
        />
      </TouchableOpacity>
    </View>
  );
};

export default TableBubble;
